import React from 'react'
import { StoredMediaCategory } from '../../../../types/Media'
import Checkbox from '../../../../components/Checkbox'

const CategoryTree: React.FC<{
    parent: StoredMediaCategory | null
    tree: StoredMediaCategory[]
    toggleCategory: (categoryId: number) => void
    selectedCategoryIds: number[]
}> = ({ parent, tree, toggleCategory, selectedCategoryIds }) => {
    const children = tree
        .filter((node) => {
            if (parent) return node.parent_id === parent.id
            else return node.parent_id === 0
        })
        .sort((a, b) => a.name.localeCompare(b.name))

    const handleCheckboxChange = (categoryId: number) => {
        toggleCategory(categoryId)
    }

    return (
        <div style={{ marginLeft: !parent ? '0rem' : '1rem' }}>
            {parent && (
                <Checkbox
                    hierarchy={'tree'}
                    property={'active'}
                    classes={'zr-mb-2 zr-mr-2 zr-flex-row zr-items-center'}
                    value={selectedCategoryIds.includes(Number(parent.id))}
                    label={parent.name}
                    onChange={() => handleCheckboxChange(Number(parent.id))}
                />
            )}
            {children.map((child) => (
                <CategoryTree
                    key={child.id}
                    parent={child}
                    tree={tree}
                    toggleCategory={toggleCategory}
                    selectedCategoryIds={selectedCategoryIds}
                />
            ))}
        </div>
    )
}

export default CategoryTree
